<template>
  <ModalContainer
    :showModal="showModal"
    title="Coupons Available"
    @closeModal="closeModal"
  >
    <div id="modal-body" class="h-96 overflow-y-scroll">
      <div class="grid gap-4 place-items-center mt-4 pr-2">
        <template v-for="(coupon, index) in availables_coupons" :key="index">
          <div class="flex gap-2 items-center w-full">
            <Coupon
              :coupon_discount="coupon.discount"
              :coupon_expired_date="coupon.expired_date"
              :coupon_product_name="coupon?.Product?.products_name"
              :coupon_max_usage="coupon.max_usage ? coupon.max_usage : '~'"
              :coupon_usage_count="coupon.usage_count || 0"
              :coupon_on_percentage="coupon?.Coupon?.on_percentage"
            />
            <button
              @click="toggleCoupon(coupon)"
              :class="[
                'border border-white rounded-xl px-2 py-1 text-xs', // Changed to rounded-md for a more rectangular button
                { 'text-black bg-white': isCouponUsed(coupon) },
              ]"
              style="font-size: 10px; border: 0.5px solid white"
            >
              {{ isCouponUsed(coupon) ? "Coupon Used" : "Use Coupon" }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </ModalContainer>
</template>

<script>
import ModalContainer from "@/components/modals/ModalContainer.vue";
import Coupon from "../molecules/Coupon.vue";
import Button from "../buttons/Button.vue";
import { formatDate, formatRupiah } from "@/helpers/formating";

export default {
  name: "ModalEditCustomer",
  props: {
    customerCoupons: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["closeModal", "appliedCoupons"],
  components: {
    ModalContainer,
    Coupon,
    Button,
  },
  data() {
    return {
      showModal: true,
      availables_coupons: this.customerCoupons,
      selectedCoupons: [],
      selected_coupons_data: [],
    };
  },
  methods: {
    formatRupiah,
    formatDate,

    isCouponUsed(coupon) {
      return this.selectedCoupons.includes(coupon.id);
    },

    toggleCoupon(coupon) {
      const couponIndex = this.selectedCoupons.indexOf(coupon.id);

      if (couponIndex === -1) {
        this.selectedCoupons.push(coupon.id);
      } else {
        this.selectedCoupons.splice(couponIndex, 1);
      }

      const selectedCouponsData = this.availables_coupons.filter((c) =>
        this.selectedCoupons.includes(c.id)
      );
      this.selected_coupons_data = selectedCouponsData;
    },

    closeModal() {
      this.$emit("appliedCoupons", this.selected_coupons_data);
      this.showModal = false;
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },
  },
};
</script>
